module.exports = __webpack_public_path__ + "static/img/print-3.dc5f41f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/print-3.png
// module id = B5uv
// module chunks = 10